// Tiny global store for "is something loading right now" — no provider,
// no context, just a module-level counter plus a subscribe list so any
// component can read it with useSyncExternalStore. api.js bumps this on
// every real network request; anything else slow (a client-side export, a
// multi-step import) can bump it too via startLoading()/stopLoading().
let count = 0;
const listeners = new Set();

function emit() {
  for (const l of listeners) l();
}

export function startLoading() {
  count += 1;
  if (count === 1) emit();
}

export function stopLoading() {
  count = Math.max(0, count - 1);
  if (count === 0) emit();
}

export function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getSnapshot() {
  return count > 0;
}

/** Wrap any async function so the global loader shows while it runs —
 * for work that doesn't go through the shared `api` instance (a client-side
 * PDF build, a bulk export loop, etc). */
export async function withLoading(fn) {
  startLoading();
  try {
    return await fn();
  } finally {
    stopLoading();
  }
}
